const question6 = {
    'question': 'Czy psychoterapeuta przepisuje leki przeciwdepresyjne?',
    'answer': 'Psychoterapeuta nie jest lekarzem, wobec tego nie ma uprawnień do przepisania recepty. W przypadku, gdy pacjent wymaga podjęcia się leczenia farmakologicznego powinien udać się na wizytę do lekarza psychiatry.',
}

export default question6;